<script>
  import { onMount } from "svelte";
  import { getProperty, randomInt } from "../Common/tools";
  import { AB_SUBJECT, getLists, getSegments, sendTestEmail } from "./static";
  import {External, M} from "../external";

  export let campaign,
    changeTab,
    cache,
    next,
    save,
    defaultEmail = "";

  let selectedListsText = "",
    selectedSegmentsText = "";

  let setListNames = () => {
    let selected = [];
    campaign.data.lists.forEach(function (list) {
      let prop = getProperty(cache.lists, "id", list.id);
      if (prop != null) {
        selected.push(prop.name);
      }
    });

    selectedListsText = M.LIST + ": " + selected.join(", ");
  };

  let setSegmentNames = () => {
    let selected = [];
    campaign.data.segments.forEach(function (segment) {
      let prop = getProperty(cache.segments, "id", segment.id);
      if (prop != null) {
        selected.push(prop.name);
      }
    });

    selectedSegmentsText = M.SEGMENT + ": " + selected.join(", ");
  };

  let addProperty = (field) => {
    field = typeof field === "string" ? field : "a";

    External.UITools.selectMarketingProperty(null, function (tag) {
      if (field === "a") {
        campaign.subject = (campaign.subject == null ? "" : campaign.subject) + "{" + tag + "}";
      } else {
        campaign.subjectB = (campaign.subjectB == null ? "" : campaign.subjectB) + "{" + tag + "}";
      }
    });
  };

  let onSend = () => {
    save(false, function () {
      sendTestEmail(campaign, defaultEmail);
    });
  };

  let editDesign = () => {
    changeTab("design");
  };

  let getThumb = () => {
    return External.getThumbnailsFromBase("s/" + campaign.dataDir + "/", "emails") + campaign.id + ".png" + "?ver=" + randomInt(10000);
  };

  let enableSalesUtm = () => {
    campaign.data.salesUtm = campaign.data.salesUtm ? null : {};
  }

  onMount(function () {
    if (campaign.data.lists && campaign.data.lists.length) {
      if (!cache.lists) {
        getLists(function (lists) {
          cache.lists = lists;
          setListNames();
        });
      } else {
        setListNames();
      }
    }

    if (campaign.data.segments && campaign.data.segments.length) {
      if (!cache.segments) {
        getSegments(function (segments) {
          cache.segments = segments;
          setSegmentNames();
        });
      } else {
        setSegmentNames();
      }
    }
  });
</script>

<div class="flex-1 overflow account-settings store-products">
  <div class="col20 f-left">
    <div class="top-background-wrapper wide-top-background">
      <div class="top-background" style="max-width: 850px;">
        <div class="text-wrapper">
          <div class="flex-centered f-left booking-buttons-wrapper none">
            <div>
              <h1 class="members-title f-left mb-0">{M.SYSTEM_EMAILS}</h1>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="content-wrapper horizontal-flex-table" style="max-width: 850px; margin-top: 100px;" data-role="table-content">
      <div class="sections-wrapper members-wrapper horizontal-flex-table">
        <div class="section-bg members-wrapper products-wrapper crm-table-outer" style="box-shadow: none; padding: 0;">
          <div class="system-emails-wrapper">
            <div class="col20 f-left t-center mb-15">
              <span class="material-icons-outlined fingerprint-icon" style="font-size: 26px;"> settings </span>
            </div>
            <h2 class="col20 f-left t-center" style="font-size: 26px;">{M.CAMPAIGN_SETTINGS}</h2>
            <div class="col20 f-left email-section-description t-center mt-10 mb-25 none" />
            <div class="col20 f-left mt-15">
              <div class="email-inputs-wrapper">
                {#if campaign.type !== AB_SUBJECT}
                  <div class="popup-input-wrapper">
                    <h5>{M.SUBJECT}</h5>
                    <span class="light-gray-text">{M.SUBJECT_DESC}</span>
                    <div class="input-inner-wrapper input-wrapper-with-button">
                      <input type="text" bind:value={campaign.subject} placeholder={M.ENTER_EMAIL_SUBJECT} />
                      <a class="middle-button light-gray-button circle-effect add-email-tags-btn" on:click={addProperty}>{M.ADD_PROPERTY}</a>
                    </div>
                  </div>
                {:else}
                  <div class="popup-input-wrapper">
                    <h5>{M.SUBJECT_A}</h5>
                    <span class="light-gray-text">{M.SUBJECT_A_DESC}</span>
                    <div class="input-inner-wrapper input-wrapper-with-button">
                      <input type="text" bind:value={campaign.subject} placeholder={M.ENTER_EMAIL_SUBJECT} />
                      <a class="middle-button light-gray-button circle-effect add-email-tags-btn" on:click={addProperty}>{M.ADD_PROPERTY}</a>
                    </div>
                  </div>
                  <div class="popup-input-wrapper">
                    <h5>{M.SUBJECT_B}</h5>
                    <span class="light-gray-text">{M.SUBJECT_B_DESC}</span>
                    <div class="input-inner-wrapper input-wrapper-with-button">
                      <input type="text" bind:value={campaign.subjectB} placeholder={M.ENTER_EMAIL_SUBJECT} />
                      <a class="middle-button light-gray-button circle-effect add-email-tags-btn" on:click={() => addProperty("b")}>{M.ADD_PROPERTY}</a>
                    </div>
                  </div>
                {/if}
                <div class="popup-input-wrapper">
                  <h5>{M.FROM_SENDER}</h5>
                  <span class="light-gray-text f-left">{M.FROM_DESC}</span>
                  <input type="text" placeholder={M.SENDER_NAME} bind:value={campaign.fromName} class="half-input f-left clear-left" />
                  <input type="text" placeholder={M.SENDER_EMAIL} autocomplete="new-password" bind:value={campaign.fromEmail} class="half-input f-right" />

                  <div style="display:none" class="red-text justify-right">
                    <span class="red-text">{M.EMAIL_WARNING_VERIFICATION}</span>
                  </div>
                </div>
                <div class="popup-input-wrapper">
                  <h5>{M.REPLY_TO}</h5>
                  <span class="light-gray-text">{M.REPLY_TO_DESC}</span>
                  <input type="text" bind:value={campaign.replyTo} placeholder={M.REPLIES_RECEIVING_EMAIL} autocomplete="new-password" />
                </div>

                <div class="popup-input-wrapper mt-5 mb-15">
                  <div class="checkbox-wrapper">
                    <input id="trackSalesCheck" class="css-checkbox select-cbx" checked={campaign.data.salesUtm}
                           type="checkbox" name="trackSalesCheck" on:change={enableSalesUtm}/>
                    <label for="trackSalesCheck" class="css-label">{M.TRACK_CAMPAIGN_SALES}</label>
                  </div>
                  {#if campaign.data.salesUtm}
                    <div class="recipients-summary f-left col20 mt-5 mb-5 gray-section">
                      <div class="info">
                        <span class="light-gray-text">{M.SALES_TRACKING_UTM_DESC}</span>
                      </div>
                      <div class="popup-input-wrapper mt-15">
                        <span class="recipients-total f-16 f-left mr-5" style="display: inline">{M.SOURCE}</span>
                        <span class="light-gray-text" style="line-height: 1.4">{M.FB_GOOGLE_NEWSLETTER}</span>
                        <input type="text" placeholder={M.SOURCE} bind:value={campaign.data.salesUtm.source} class="col20 f-left clear-left" style="margin-top: 5px" />
                      </div>
                      <div class="popup-input-wrapper">
                        <span class="recipients-total f-16 f-left mr-5" style="display: inline">{M.CAMPAIGN}</span>
                        <span class="light-gray-text" style="line-height: 1.4">{M.DEAL_PROMOTION}</span>
                        <input type="text" placeholder={M.CAMPAIGN} bind:value={campaign.data.salesUtm.campaign} class="col20 f-left clear-left" style="margin-top: 5px"/>
                      </div>
                      <div class="popup-input-wrapper">
                        <span class="recipients-total f-16 f-left mr-5" style="display: inline">{M.UTM_MEDIUM}</span>
                        <span class="light-gray-text" style="line-height: 1.4">{M.SOCIAL_PPC_EMAIL}</span>
                        <input type="text" placeholder={M.UTM_MEDIUM} bind:value={campaign.data.salesUtm.medium} class="col20 f-left clear-left" style="margin-top: 5px"/>
                      </div>
                    </div>
                  {/if}
                </div>

                <h5 class="col20 f-left mt-15 f-18">{M.RECIPIENTS}</h5>
                <div class="recipients-summary f-left col20 mt-10 gray-section">
                  <span class="col20 f-left recipients-total f-16">{M.TOTAL} {campaign.data.audience || 0}</span>
                  {#if selectedListsText}
                    <span class="col20 f-left recipients-listed mt-5">{selectedListsText}</span>
                  {/if}
                  {#if selectedSegmentsText}
                    <span class="col20 f-left recipients-listed mt-5">{selectedSegmentsText}</span>
                  {/if}
                </div>

                <h5 class="col20 f-left mt-35 f-18">{M.CONTENT}</h5>
                <div class="recipients-summary f-left col20 mt-10 gray-section flex align-center">
                  <img alt="" class="system-email-box-img" src={getThumb()} style="margin-right: 15px;" />
                  <div>
                    <a class="middle-button blue mr-5" on:click={onSend}>{M.SEND_TEST_EMAIL}</a>
                    <a class="middle-button light-gray-button circle-effect" on:click={editDesign}>{M.EDIT_EMAIL}</a>
                  </div>
                </div>

                <div class="col20 f-left flex justify-center mt-35 mb-35">
                  <a data-action="nextPage" on:click={next} class="big-button blue circle-effect transition-bg f-left" style="margin-left:5px;">{M.NEXT} →</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
